/* Copyright (c) 2017 Backpack Health LLC */
/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

import { medliTermConversions } from './medliTerm';

function singleAnatomy(healthEntryCategoryState, languageCode) {
  healthEntryCategoryState.anatomy = healthEntryCategoryState.anatomy || {};

  return {
    allowsMany: () => false,
    get: () => healthEntryCategoryState.anatomy,
    getUnique: () => healthEntryCategoryState.anatomy,
    hasAnatomy: () => !!healthEntryCategoryState.anatomy.id,
    set: (anatomy) => { healthEntryCategoryState.anatomy = anatomy; },
    addMedliSearchTerm: (medliSearchTerm) => {
      const newTerm = medliTermConversions.convertSearchTermToTerm(medliSearchTerm, languageCode);
      healthEntryCategoryState.anatomy = newTerm;
    },
    remove: () => { healthEntryCategoryState.anatomy = {}; },
    count: () => (healthEntryCategoryState.anatomy.id ? 1 : 0),
    formattedNames: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return healthEntryCategoryState.anatomy.id ? healthEntryCategoryState.anatomy.strings[code] : '';
    },
  };
}

export function cleanSingleAnatomy(healthEntryCategoryState) {
  const anatomyId = _.get(healthEntryCategoryState, 'anatomy.id', '');
  if (anatomyId === '' || anatomyId === null) {
    healthEntryCategoryState = _.omit(healthEntryCategoryState, ['anatomy']);
  }

  return healthEntryCategoryState;
}

export default singleAnatomy;
